import { useEffect, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { Text } from 'foundations-components/components/Text';
import { TALK_TO_SALES_SUB_MODALS } from '../../../constants/talkToSales';
import { loadAndOpenSalesChat } from '../../../utils/loadAndOpenSalesChat';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
import { CallSalesModal } from './CallSalesModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UnassignableModal = ({
  apiName,
  isRetail,
  trackingData,
  onClose
}) => {
  const [currentSubModal, setCurrentSubModal] = useState();
  const hideSubModal = () => setCurrentSubModal(undefined);
  const showCallUsModal = () => setCurrentSubModal(TALK_TO_SALES_SUB_MODALS.CALL_US);
  const showChat = () => {
    loadAndOpenSalesChat({
      apiName,
      trackingData,
      isRetail
    });
    track('communicationMethodsInteraction', Object.assign({
      action: 'clicked chat with us'
    }, getTrackingProperties({
      apiName,
      trackingData
    })));
    onClose();
  };
  useEffect(() => {
    if (isRetail) {
      track('communicationMethodsInteraction', Object.assign({
        action: 'viewed retail modal'
      }, getTrackingProperties({
        apiName,
        trackingData
      })));
      //submitPql({ ...upgradeData, isRetail: true, isAssignable: false }).catch(
      //  (error) => {
      //    console.error(error);
      //    Raven.captureException(
      //      new Error('Error submitting PQL with retail modal'),
      //      {
      //        extra: { error },
      //      }
      //    );
      //  }
      //);
      //trackTalkToSalesPql(upgradeData.app);
    } else {
      track('communicationMethodsInteraction', Object.assign({
        action: 'viewed unassignable modal'
      }, getTrackingProperties({
        apiName,
        trackingData
      })));
      //submitPql({ ...upgradeData, isRetail: false, isAssignable: false }).catch(
      //  (error) => {
      //    console.error(error);
      //    Raven.captureException(
      //      new Error('Error submitting PQL with unassignable modal'),
      //      {
      //        extra: { error },
      //      }
      //    );
      //  }
      //);
      //trackTalkToSalesPql(upgradeData.app);
    }
  }, [apiName, trackingData, isRetail]);
  if (currentSubModal) {
    switch (currentSubModal) {
      case TALK_TO_SALES_SUB_MODALS.CALL_US:
        return /*#__PURE__*/_jsx(CallSalesModal, {
          onBackClick: hideSubModal,
          onClose: onClose
        });
      default: //no-op
    }
  }
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    width: 550,
    "data-test-id": "unassignable-modal",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        marginBlockEnd: "800",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.talkToSales.communicationMethods.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose()
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      paddingBlockEnd: "1000",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "stretch",
        justifyContent: "center",
        gap: "300",
        children: [/*#__PURE__*/_jsx(SelectableButton, {
          "data-test-id": "unassignable-call",
          size: "large",
          width: 200,
          onClick: showCallUsModal,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.talkToSales.communicationMethods.callUs"
          }),
          children: /*#__PURE__*/_jsx(Illustration, {
            name: "calling-small",
            height: 75
          })
        }), /*#__PURE__*/_jsx(SelectableButton, {
          "data-test-id": "unassignable-chat",
          selected: false,
          size: "large",
          width: 200,
          onClick: showChat,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.talkToSales.communicationMethods.chatWithUs"
          }),
          children: /*#__PURE__*/_jsx(Illustration, {
            name: "contacts-chat",
            height: 75
          })
        })]
      })
    })]
  });
};